import React from 'react';
import { Button } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import { IconImage } from 'ai/components/SuperChat/SuperChatHeader';
import { fontWeights, space, colors } from 'style/config';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import EN from 'ai/components/SuperChat/locales/SuperChat_en_US';
import FR from 'ai/components/SuperChat/locales/SuperChat_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(EN, FR);

function FeedbackButtonDesktop({ iconSrc, onIconClick, showFlyer }) {
    const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

    return (
        <Button
            variant='special'
            onClick={onIconClick}
            css={styles.headerButton}
            display={['none', 'flex', 'flex']}
            width='fit-content'
        >
            {isGenAINewUIEnabled && !showFlyer ? <span css={styles.feedbackText}>{getText('feedback')}</span> : <IconImage src={iconSrc} />}
        </Button>
    );
}

const styles = {
    headerButton: {
        minWidth: space[5],
        minHeight: space[5],
        height: space[5],
        padding: space[0],
        cursor: 'pointer',
        border: 'none',
        background: 'transparent',
        fontWeight: fontWeights.normal,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        '&:hover': {
            background: 'transparent !important',
            color: colors.darkGray
        }
    },
    feedbackText: {
        color: colors.darkGray
    }
};

export default wrapFunctionalComponent(FeedbackButtonDesktop, 'FeedbackButtonDesktop');
